import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconArchive$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArchive extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7f897bb97dcdd6d8e1cfa543996e103d9cd9e5b0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'de448427639bf59ab41361b4b682bb3da51475a2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9b41904562fccaaa590dec875fe23f4e70a06b5f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 3a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5zm13 14.5v-6a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 .5.5v6zm-8-5.47a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zm9-4.53v-3h-13v3z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-archive", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-archive"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-archive":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArchive$1);
            }
            break;
    } });
}

const CosmosIconArchive = CosmosIconArchive$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArchive, defineCustomElement };
